import { forwardRef } from 'react';

export const ChannelGoogle = forwardRef<SVGSVGElement, React.JSX.IntrinsicAttributes & React.SVGProps<SVGSVGElement>>(
  (props, ref) => (
    <svg
      width="1em"
      height="1em"
      fill="none"
      viewBox="0 0 24 24"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      ref={ref}
    >
      <path
        d="M6.43254 14.0872L5.73635 16.6862L3.19179 16.74C2.43134 15.3295 2 13.7158 2 12.0009C2 10.3426 2.40329 8.77881 3.11815 7.40186H3.1187L5.38407 7.81718L6.37644 10.069C6.16874 10.6745 6.05554 11.3245 6.05554 12.0009C6.05561 12.735 6.18859 13.4383 6.43254 14.0872Z"
        fill="#FBBB00"
      />
      <path
        d="M21.8244 10.1328C21.9393 10.7378 21.9992 11.3625 21.9992 12.001C21.9992 12.7169 21.9239 13.4153 21.7805 14.089C21.2937 16.3813 20.0217 18.383 18.2595 19.7996L18.259 19.799L15.4056 19.6534L15.0018 17.1324C16.171 16.4467 17.0848 15.3736 17.5662 14.089H12.2188V10.1328H21.8244Z"
        fill="#518EF8"
      />
      <path
        d="M18.2599 19.7996L18.2605 19.8001C16.5467 21.1776 14.3697 22.0018 11.9999 22.0018C8.19154 22.0018 4.88047 19.8732 3.19141 16.7407L6.43215 14.0879C7.27667 16.3418 9.45091 17.9462 11.9999 17.9462C13.0955 17.9462 14.1219 17.6501 15.0027 17.133L18.2599 19.7996Z"
        fill="#28B446"
      />
      <path
        d="M18.3824 4.30225L15.1428 6.9545C14.2312 6.38472 13.1537 6.05557 11.9993 6.05557C9.39262 6.05557 7.17772 7.73363 6.37551 10.0683L3.11773 7.40124H3.11719C4.78153 4.19236 8.13435 2 11.9993 2C14.4257 2 16.6505 2.86432 18.3824 4.30225Z"
        fill="#F14336"
      />
    </svg>
  ),
);
